import { store } from '../../../../../app/store'
import {
  getScoreRangesCreditRisk,
  getScoreRangesPerformance,
} from '../../../../companyAnalysis/common/header/companyInfo/store/thunk'
import { CorporateLinkageScore } from '../../../../companyAnalysis/score/corporatePerformanceScore/components/bottomComponent/components/premiumUser/corporateLinkageScore'
import { getLinkageScore } from '../../../../companyAnalysis/score/corporatePerformanceScore/components/bottomComponent/components/premiumUser/corporateLinkageScore/store/thunk'
import { PerformanceScore } from '../../../../companyAnalysis/score/corporatePerformanceScore/components/bottomComponent/components/premiumUser/performanceScore'
import {
  selectListCheckDynamicPerformance,
  selectTypeRadioDynamicPerformance,
} from '../../../../companyAnalysis/score/corporatePerformanceScore/components/bottomComponent/components/premiumUser/performanceScore/bottomContent/store/slice'
import {
  getDistributionPerformance,
  getTrendOfScorePerformance,
} from '../../../../companyAnalysis/score/corporatePerformanceScore/components/bottomComponent/components/premiumUser/performanceScore/bottomContent/store/thunk'
import { getScorePerformance } from '../../../../companyAnalysis/score/corporatePerformanceScore/components/bottomComponent/components/premiumUser/performanceScore/store/thunk'
import { selectTypePeriod } from '../../../../companyAnalysis/score/corporatePerformanceScore/store/slice'
import { getUnique } from '../../../../helpers/common'
import { COMPANY_TYPES } from '../../../../utils/common'
import {
  KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS,
  MAIN_SCREEN,
  SCREEN,
  TYPE_INFORMATION_PANEL,
  TYPE_ITEM_SETTING,
  VALUE_SCORE_ANALYSIS,
} from '../../constant'

const PANELS = {
  PERFORMANCE_SCORE: 'performanceScore',
  CORPORATE_LINKAGE_SCORE: 'corporateLinkageScore',
}

const SETTING_PANEL = {
  items: [
    {
      type: TYPE_INFORMATION_PANEL.CHECKBOX,
      value: VALUE_SCORE_ANALYSIS.SCORE_BAR,
      key: KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.SCORE_ANALYSIS,
      title: 'dynamicReport.SCORE_BAR',
    },
    {
      type: TYPE_INFORMATION_PANEL.CHECKBOX,
      value: VALUE_SCORE_ANALYSIS.TREND_OF_SCORE,
      key: KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.SCORE_ANALYSIS,
      title: 'score.premium.TREND_OF_SCORE',
      isInline: true,
      children: [
        {
          type: TYPE_INFORMATION_PANEL.RADIO,
          value: VALUE_SCORE_ANALYSIS.YEARLY,
          key: KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.TIME_PERIOD,
          title: 'companyAnalysis.industryAnalysis.YEARLY',
        },
        {
          type: TYPE_INFORMATION_PANEL.RADIO,
          value: VALUE_SCORE_ANALYSIS.QUARTERLY,
          key: KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.TIME_PERIOD,
          title: 'companyAnalysis.industryAnalysis.QUARTERLY',
        },
        {
          type: TYPE_INFORMATION_PANEL.RADIO,
          value: VALUE_SCORE_ANALYSIS.MONTHLY,
          key: KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.TIME_PERIOD,
          title: 'companyAnalysis.industryAnalysis.MONTHLY',
        },
        {
          type: TYPE_INFORMATION_PANEL.CHECKBOX,
          value: VALUE_SCORE_ANALYSIS.COMPANY,
          key: KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.SCORE_ANALYSIS,
          title: 'score.premium.DYNAMIC.COMPANY',
          isRequire: true,
          isBreakLine: true,
        },
        {
          type: TYPE_INFORMATION_PANEL.CHECKBOX,
          value: VALUE_SCORE_ANALYSIS.INDUSTRY,
          key: KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.SCORE_ANALYSIS,
          title: 'score.premium.DYNAMIC.INDUSTRY',
          isBreakLine: true,
        },
        {
          type: TYPE_INFORMATION_PANEL.CHECKBOX,
          value: VALUE_SCORE_ANALYSIS.REGION,
          key: KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.SCORE_ANALYSIS,
          title: 'score.premium.DYNAMIC.REGION',
          isBreakLine: true,
        },
        {
          type: TYPE_INFORMATION_PANEL.CHECKBOX,
          value: VALUE_SCORE_ANALYSIS.YEAR,
          key: KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.SCORE_ANALYSIS,
          title: 'score.premium.DYNAMIC.YEAR',
          isBreakLine: true,
        },
      ],
    },
    {
      type: TYPE_INFORMATION_PANEL.CHECKBOX,
      value: VALUE_SCORE_ANALYSIS.DISTRIBUTION_CHART,
      key: KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.SCORE_ANALYSIS,
      title: 'score.premium.DISTRIBUTION.NAME_CHART',
      children: [
        {
          type: TYPE_INFORMATION_PANEL.RADIO,
          value: VALUE_SCORE_ANALYSIS.BY_INDUSTRY,
          key: KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.TYPE_DISTRIBUTION,
          title: 'score.premium.DISTRIBUTION.INDUSTRY',
          isBreakLine: true,
        },
        {
          type: TYPE_INFORMATION_PANEL.RADIO,
          value: VALUE_SCORE_ANALYSIS.BY_REGION,
          key: KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.TYPE_DISTRIBUTION,
          title: 'score.premium.DISTRIBUTION.REGION',
          isBreakLine: true,
        },
        {
          type: TYPE_INFORMATION_PANEL.RADIO,
          value: VALUE_SCORE_ANALYSIS.BY_YEAR,
          key: KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.TYPE_DISTRIBUTION,
          title: 'score.premium.DISTRIBUTION.YEAR',
          isBreakLine: true,
        },
      ],
    },
  ],
}

export const getPanelListCorporatePerformanceScore = (companyType) => {
  if ([COMPANY_TYPES.BANK, COMPANY_TYPES.SECURITIES].includes(companyType)) {
    return []
  }

  return [
    {
      label: 'dynamicReport.CORPORATE_PERFORMANCE_SCORE',
      children: [
        {
          screen:
            SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].CORPORATE_PERFORMANCE_SCORE,
          panel: PANELS.PERFORMANCE_SCORE,
          label: 'dynamicReport.CORPORATE_PERFORMANCE_SCORE',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            [KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.SCORE_ANALYSIS]: [
              VALUE_SCORE_ANALYSIS.SCORE_BAR,
              VALUE_SCORE_ANALYSIS.COMPANY,
              VALUE_SCORE_ANALYSIS.TREND_OF_SCORE,
              VALUE_SCORE_ANALYSIS.INDUSTRY,
              VALUE_SCORE_ANALYSIS.REGION,
              VALUE_SCORE_ANALYSIS.YEAR,
              VALUE_SCORE_ANALYSIS.DISTRIBUTION_CHART,
            ],
            [KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.TIME_PERIOD]:
              VALUE_SCORE_ANALYSIS.YEARLY,
            [KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.TYPE_DISTRIBUTION]:
              VALUE_SCORE_ANALYSIS.BY_INDUSTRY,
          },
        },
        {
          screen:
            SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].CORPORATE_PERFORMANCE_SCORE,
          panel: PANELS.CORPORATE_LINKAGE_SCORE,
          label: 'dynamicReport.CORPORATE_LINKAGE_SCORE',
          type: TYPE_ITEM_SETTING.PANEL,
        },
      ],
    },
  ]
}

export const checkOnlyDetails = (setting) => {
  const arrValueNumber = setting.filter(Number)
  if (
    arrValueNumber.includes(VALUE_SCORE_ANALYSIS.SCORE_BAR) &&
    arrValueNumber.length === 1
  ) {
    return false
  }
  return true
}

export const getPanelCorporatePerformanceScore = (panel, setting) => {
  const settingScore =
    setting[KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.SCORE_ANALYSIS]
  const isOnlyDetails = !settingScore ? true : checkOnlyDetails(settingScore)

  switch (panel) {
    case PANELS.PERFORMANCE_SCORE:
      return {
        renderComponent: () => {
          return <PerformanceScore isDynamicReport settingDynamic={setting} />
        },
        thunk: [
          ({ companyInfo }) =>
            getTrendOfScorePerformance({
              OrganizationId: companyInfo.organizationId,
              TimeFrequency:
                setting[KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.TIME_PERIOD],
            }),
          ({ companyInfo }) =>
            getDistributionPerformance({
              OrganizationId: companyInfo.organizationId,
            }),
          ({ companyInfo }) =>
            getScorePerformance({
              OrganizationId: companyInfo.organizationId,
            }),
          () => getScoreRangesPerformance(),
        ],
        settingPanel: SETTING_PANEL,
        isWaitForMount: isOnlyDetails,
        isTable: false,
      }
    case PANELS.CORPORATE_LINKAGE_SCORE:
      return {
        renderComponent: () => {
          return <CorporateLinkageScore isDynamicReport />
        },
        width: 800,
        thunk: [
          ({ companyInfo }) =>
            getLinkageScore({ OrganizationId: companyInfo.organizationId }),
          () => getScoreRangesCreditRisk(),
          () => getScoreRangesPerformance(),
        ],
        isWaitForMount: true,
        isTable: true,
      }
    default:
      break
  }
}

export const getDefaultScore = (companyType) => {
  const typePeriod = selectTypePeriod(store.getState())
  const typeRadioDistributionPer = selectTypeRadioDynamicPerformance(
    store.getState(),
  )
  const listCheckPerformance = selectListCheckDynamicPerformance(
    store.getState(),
  )

  const settingByKey = {
    performanceScore: {
      [KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.SCORE_ANALYSIS]: [
        VALUE_SCORE_ANALYSIS.SCORE_BAR,
        VALUE_SCORE_ANALYSIS.COMPANY,
        VALUE_SCORE_ANALYSIS.TREND_OF_SCORE,
        VALUE_SCORE_ANALYSIS.DISTRIBUTION_CHART,
        ...listCheckPerformance,
      ],
      [KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.TIME_PERIOD]: typePeriod,
      [KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.TYPE_DISTRIBUTION]:
        typeRadioDistributionPer,
    },
    corporateLinkageScore: {},
  }

  if ([COMPANY_TYPES.BANK, COMPANY_TYPES.SECURITIES].includes(companyType)) {
    return []
  }

  return getPanelListCorporatePerformanceScore(companyType)[0].children.map(
    (panel) => ({
      id: getUnique(),
      ...panel,
      setting: settingByKey[panel.panel],
    }),
  )
}
